import { Navigate } from 'react-router-dom';

export function MissingRoute() {
 return < Navigate to={{pathname: '/'}} / >
}
